/* eslint-disable no-param-reassign */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import overviewAPI from 'src/api/overview';

export const getSourceOfLeads = createAsyncThunk('sourceOfLeads/get', async arg => {
  return overviewAPI.getSourceOfLeads(arg);
});

const Slice = createSlice({
  name: 'sourceOfLeads',
  initialState: {
    isTabExpended: true,
    status: 'loading',
    message: '',
    data: [],
    arg: false,
  },
  reducers: {
    setTabExpend: (state, action) => {
      state.isTabExpended = action.payload;
    },
  },
  extraReducers: {
    [getSourceOfLeads.pending]: (state, action) => {
      state.status = 'loading';
      state.arg = action.meta.arg;
    },
    [getSourceOfLeads.fulfilled]: (state, action) => {
      const { status, message, data } = action.payload;
      state.status = status;
      state.message = message;
      state.data = data;
    },
    [getSourceOfLeads.rejected]: () => {},
  },
});

export const { setTabExpend } = Slice.actions;
export default Slice.reducer;
